import "./styles.css";
import "leaflet/dist/leaflet.css";

import React from "react";
import {Route, Routes, useLocation} from "react-router-dom";
import {Box} from "@mui/material";
import MainPage from "./mainpage/MainPage";
import SignUp from "./login/SignUp";
import Login from "./login/Login";
import ForgotPassword from "./login/ForgotPassword";
import ResetPassword from "./login/ResetPassword";
import EditProfile from "./login/EditProfile";
import CompanyPage from "./company/CompanyPage";
import EmailConfirmed from "./login/EmailConfirmed";
import Header from "./common/Header";
import Footer from "./common/Footer";

const KNOWN_PAGES = ['/signup', '/login', '/forgot-password', '/reset-password', '/email-confirmed', '/company', '/edit-profile'];

export default function App() {
  const location = useLocation();
  const isMapPage = !KNOWN_PAGES.includes(location.pathname);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
      }}
    >
      {!isMapPage && <Header />}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: 'var(--footer-height, 64px)',
        }}
      >
        <Routes>
          <Route path="/" element={<MainPage/>}/>
          <Route path="/:slug" element={<MainPage />} />
          <Route path="/signup" element={<SignUp/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/forgot-password" element={<ForgotPassword/>}/>
          <Route path="/reset-password" element={<ResetPassword/>}/>
          <Route path="/email-confirmed" element={<EmailConfirmed/>}/>
          <Route path="/company" element={<CompanyPage/>}/>
          <Route path="/edit-profile" element={<EditProfile/>}/>
        </Routes>
      </Box>
      <Footer />
    </Box>
  )
}
